export default __webpack_public_path__ + "static/media/09.ffcfb32f.jpg";